import sliceCreator from '../../index.jsx';
import {GET_ALL_POST_SEASON_ACTIVITIES} from '../../../constants/index.jsx';
const _getAllPostSeasonActivitiesAction = sliceCreator('GET_ALL_POST_SEASON_ACTIVITIES', GET_ALL_POST_SEASON_ACTIVITIES, 'get');

const { asyncAction: getAllPostSeasonActivitiesAction, reducer, clearData: clearGetAllPostSeasonActivitiesAction } = _getAllPostSeasonActivitiesAction;

export default reducer;

export {
    getAllPostSeasonActivitiesAction,
    clearGetAllPostSeasonActivitiesAction
}